export const enum SharingAudience {
    specificPeople = 0,
    organization = 1,
    anyone = 2,
    existing = 3,
    specificPeopleFlex = 4, // Have to add to distinguish option in PermissionsSettings.
    customLabeledSpecificPeople = 5
}
